
import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

interface ContactHeroProps {
  backgroundImage: string;
}

const ContactHero: React.FC<ContactHeroProps> = ({ backgroundImage }) => {
  return (
    <div className="relative">
      <div
        className="bg-cover bg-center h-[400px] flex items-center relative overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(44, 85, 48, 0.9), rgba(140, 198, 63, 0.8)), url('${backgroundImage}')`
        }}
      >
        {/* Decorative elements */}
        <div className="absolute inset-0">
          <div className="absolute top-10 right-10 w-32 h-32 bg-white/10 rounded-full blur-xl"></div>
          <div className="absolute bottom-10 left-10 w-24 h-24 bg-fabre-green/20 rounded-full blur-lg"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl text-white">
            <div className="flex items-center mb-6">
              <div className="w-2 h-16 bg-fabre-green mr-6"></div>
              <div>
                <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4 leading-tight">
                  CONTACTEZ-NOUS
                </h1>
                <p className="text-xl md:text-2xl opacity-90 font-light">
                  Notre équipe d'experts vous accompagne dans tous vos projets
                </p>
              </div>
            </div>
            
            {/* Quick contact info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
              <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <Phone className="h-6 w-6 text-fabre-green" />
                <div>
                  <p className="text-sm opacity-80">Appelez-nous</p>
                  <p className="font-semibold">05.65.67.82.05</p>
                </div>
              </div>
              <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <Mail className="h-6 w-6 text-fabre-green" />
                <div>
                  <p className="text-sm opacity-80">Email</p>
                  <p className="font-semibold">contactgfe@groupefabre.com</p>
                </div>
              </div>
              <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <MapPin className="h-6 w-6 text-fabre-green" />
                <div>
                  <p className="text-sm opacity-80">Siège social</p>
                  <p className="font-semibold">12000 Rodez</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Modern wave decoration */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-[60px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path fill="#ffffff" fillOpacity="1" d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,64C960,75,1056,85,1152,80C1248,75,1344,53,1392,42.7L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default ContactHero;
